import { Box } from "@mui/material";

export default function ProfileImage({
  image,
  expandImage,
  t
}) {
  return (
    <Box className="my-2 first-of-type:my-0 last-of-type:my-0">
      <img
        onClick={expandImage}
        className="w-full rounded-md" 
        src={image.url} 
        alt={t("profileImage")}
      />
    </Box>
  );
}
